import { View, Text, Image } from '@react-pdf/renderer';
import React from 'react';

import { AttractorField } from '@/components/PDFDownload/Components/PDFFields';
import { PDFFormatting, PDFTextStyles } from '@/components/PDFDownload/styles';

import ankleStiffness from '@/assets/avatars/run/analysis/AnkleStiffness.png';
import footPlant from '@/assets/avatars/run/analysis/FootPlant.png';
import hipLock from '@/assets/avatars/run/analysis/HipLock.png';
import kneeAngleMidswing from '@/assets/avatars/run/analysis/KneeAngleMidswing.png';
import kneeExtensionPreswing from '@/assets/avatars/run/analysis/KneeExtensionPreswing.png';
import kneeFlexionMidstance from '@/assets/avatars/run/analysis/kneeFlexionMidstance.png';
import positiveRunningMidstance from '@/assets/avatars/run/analysis/PositiveRunningMidstance.png';
import positiveRunningToeOff from '@/assets/avatars/run/analysis/PositiveRunningToeOff.png';
import projectionFootplant from '@/assets/avatars/run/analysis/ProjectionFootplant.png';
import scissors from '@/assets/avatars/run/analysis/Scissors.png';
import swingLegRecovery from '@/assets/avatars/run/analysis/SwingLegRecovery.png';
import swingLegRetraction from '@/assets/avatars/run/analysis/SwingLegRetraction.png';

type AttractorLabels = string[][];

type AttractorCardProps = {
  title: string;
  subtitle?: string;
  img: string;
  labels: string[];
};

/** Report card for kpi data
 * @param img - The avatar
 * @param kpiRow - Tuple of (Left, Right) kpi values
 * @param labels - rows of kpi labels, row 0 is Left, row 1 is Right
 */
const AttractorCard = ({ title, subtitle, img, labels }: AttractorCardProps) => (
  <View debug={false} style={PDFFormatting.attractorCardContainer}>
    <Text style={PDFTextStyles.title}>{title}</Text>
    <Text style={PDFTextStyles.subtitle}>{subtitle}</Text>
    <Image src={img} style={PDFFormatting.avatar_NoMargin} />
    <View style={PDFFormatting.cardResultContainer}>
      <AttractorField name={'Left'} value={labels[0]} />
      <AttractorField name={'Right'} value={labels[1]} />
    </View>
  </View>
);

type RunReportProps = {
  attractorLabels: AttractorLabels;
};

export const RunAnalysisCards = ({ attractorLabels }: RunReportProps) => {
  return (
    <>
      <View style={PDFFormatting.KpiCardscontainer}>
        <AttractorCard
          img={ankleStiffness}
          labels={attractorLabels[1]}
          subtitle={'Terminal stance'}
          title={'Ankle stiffness'}
        />
        <AttractorCard
          img={kneeExtensionPreswing}
          labels={attractorLabels[2]}
          subtitle={'Terminal stance'}
          title={'Knee extension'}
        />
        <AttractorCard img={hipLock} labels={attractorLabels[3]} subtitle={'Terminal stance'} title={'Hip Lock'} />
        <AttractorCard
          img={positiveRunningToeOff}
          labels={attractorLabels[0]}
          subtitle={'Toe-off'}
          title={'Positive running'}
        />
      </View>
      <View style={PDFFormatting.KpiCardscontainer}>
        <AttractorCard
          img={swingLegRecovery}
          labels={attractorLabels[5]}
          subtitle={'Initial swing'}
          title={'Swing leg recovery'}
        />
        <AttractorCard
          img={kneeAngleMidswing}
          labels={attractorLabels[6]}
          subtitle={'Midswing'}
          title={'Knee flexion'}
        />
        <AttractorCard
          img={swingLegRetraction}
          labels={attractorLabels[9]}
          subtitle={'Terminal swing'}
          title={'Swing leg retraction'}
        />
        <AttractorCard
          img={scissors}
          labels={attractorLabels[10]}
          subtitle={'Terminal swing'}
          title={'Scissors motion'}
        />
      </View>
      <View style={PDFFormatting.KpiCardscontainer}>
        <AttractorCard
          img={footPlant}
          labels={attractorLabels[11]}
          subtitle={'Midstance'}
          title={'Footplant from above'}
        />
        <AttractorCard
          img={projectionFootplant}
          labels={attractorLabels[8]}
          subtitle={'Midstance'}
          title={'Projection footplant'}
        />
        <AttractorCard
          img={kneeFlexionMidstance}
          labels={attractorLabels[14]}
          subtitle={'Midstance'}
          title={'Knee flexion'}
        />
        <AttractorCard
          img={positiveRunningMidstance}
          labels={attractorLabels[7]}
          subtitle={'Midstance'}
          title={'Positive running'}
        />
      </View>
    </>
  );
};
